import { CatalogVacancies } from '../../../redux/reducers/catalogReducer';
import { VariantBG } from '../../UI/Tag/Tag.types';

export const getTagsList = (item: CatalogVacancies) => {
  const tags: string[] = [];

  if (item.city) {
    tags.push(item.city);
  }

  if (item.group) {
    tags.push(item.group);
  }

  if (item.grade && item.grade.length > 0) {
    tags.push(...item.grade);
  }

  if (item.role && item.role.length > 0) {
    tags.push(item.role);
  }

  return tags.filter(Boolean);
};

export const getMainTag = (item: string) : {value: string, color: VariantBG} => {
  let color: VariantBG = 'default';

  switch (item) {
    case 'Tech':
      color = 'dark';
      break;
    case 'Back office':
      color = 'orangeReversed';
      break;
    case 'Operations':
      color = 'orange';
      break;
    default:
      color = 'orange';
      break;
  }

  return {
    value: item,
    color,
  };
};
